<template>
  <div class="formDocs">
    <h1 class="large-title">Form Input</h1>
    <div class="form-group">
      <adx-input :label="`What is your name ?`" />
      <adx-input :label="`name`" :value="`John Doe`" />
      <adx-input :label="`name`" :value="`John Doe`" :error="`Form validations message goes here!`" />
    </div>
    <h1 class="large-title">Form Input with icon</h1>
    <div class="form-group">
      <adx-input :label="`name`" :icon="`icon-hammer`" />
      <adx-input :label="`name`" :value="`John Doe`" :icon="`icon-hammer`" />
      <adx-input :label="`name`" :value="`John Doe`" :error="`Form validations message goes here!`" :icon="`icon-hammer`" />
    </div>
    <h1 class="large-title">Form Input with button</h1>
    <div class="form-group">
      <adx-input :label="`name`" :icon="`icon-hammer`" :button="`Click Here`" />
      <adx-input :label="`name`" :value="`John Doe`" :button="`Click Here`" />
      <adx-input :label="`name`" :value="`John Doe`" :error="`Form validations message goes here!`" :button="`Click Here`" />
    </div>
    <h1 class="large-title">Form Textarea</h1>
    <div class="form-group">
      <adx-textarea :label="`Comment`" />
      <adx-textarea :label="`Comment`" :value="`Form text area when input here Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod`" />
      <adx-textarea :label="`Comment`" :value="`Form text area when input here Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod`" :error="`Form validations message goes here!`" />
    </div>
    <h1 class="large-title">Form Dropdown</h1>
    <div class="form-group">
      <adx-selectdropdown :label="`Select option here`" :options="dropdown" />
      <adx-selectdropdown :label="`Select option here`" :value="dropdown[0].value" :options="dropdown" />
      <adx-selectdropdown :label="`Select option here`" :value="dropdown[0].value" :error="`Form validations message goes here!`" :options="dropdown" />
    </div>
    <h1 class="large-title">Form Checkbox and Radio</h1>
    <div class="form-group">
      <adx-checkbox :label="`Form checkbox checked`" :value="`agree`" :valueLabel="`agree`" />
      <adx-checkbox :label="`Form checkbox unchecked`" />
    </div>
    <div class="form-group">
      <adx-radio :grup="`radio1`" :options="radioOptions" :formStyle="`block`" :value="`male`" />
    </div>
    <h1 class="large-title">Form Wrapper inline</h1>
    <div class="form-group form-inline">
      <adx-input :label="`name`" />
      <adx-input :label="`name`" />
    </div>
    <div class="form-group form-inline">
      <adx-textarea :label="`Comment`" />
      <adx-textarea :label="`Comment`" />
    </div>
    <div class="form-group form-inline">
      <adx-selectdropdown :label="`Select option here`" :options="dropdown" />
      <adx-selectdropdown :label="`Select option here`" :options="dropdown" />
    </div>
    <div class="form-group form-inline">
      <adx-multiple-checkbox :value="multipleCheckBox.value" :options="multipleCheckBox.options"/>
    </div>
    <div class="form-group form-inline">
      <adx-radio :grup="`radio2`" :options="radioOptions1" :value="`other`" />
    </div>
  </div>
</template>

<script>
import Input from '@/components/Form/Input'
import Textarea from '@/components/Form/TextArea'
import SelectDropdown from '@/components/Form/SelectDropdown'
import Checkbox from '@/components/Form/Checkbox'
import MultipleCheckbox from '@/components/Form/MultipleCheckbox'
import Radio from '@/components/Form/Radio'

export default {
  name: 'adx-form-docs',
  components: {
    'adx-input': Input,
    'adx-textarea': Textarea,
    'adx-selectdropdown': SelectDropdown,
    'adx-checkbox': Checkbox,
    'adx-multiple-checkbox': MultipleCheckbox,
    'adx-radio': Radio
  },
  data(){
    return {
      dropdown: [
        {
          label: 'Select option dropdown here 1',
          value: 'value_1'
        },
        {
          label: 'Select option dropdown here 2',
          value: 'value_2'
        },
        {
          label: 'Select option dropdown here 3',
          value: 'value_3'
        }
      ],
      radioOptions: [
        {
          label: 'Male',
          value: 'male',
        },
        {
          label: 'Female',
          value: 'female',
        }
      ],
      radioOptions1: [
        {
          label: 'Male',
          value: 'male',
        },
        {
          label: 'Female',
          value: 'female',
        },
        {
          label: 'Other',
          value: 'other',
        }
      ],
      multipleCheckBox: {
        value: ['jakarta', 'bali'],
        options: [
          {
            label: 'Jakarta',
            value: 'jakarta'
          },
          {
            label: 'Bandung',
            value: 'bandung'
          },
          {
            label: 'Bali',
            value: 'bali'
          }
        ]
      }
    }
  },
  mounted(){
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>